import { ButtonType, EpicIcons } from "@constellation-academy/epic-ui";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { ProductFormProps, ProductFormState } from "./product-form.types";
import { Button } from "../../../../components/button";
import {
	DefaultPriceFieldComponent,
	DefaultSwitchComponent,
	DefaultTextFieldComponent,
} from "../../../../components/DefaultTextInput";
import { ValidatedField } from "../../../../components/ValidatedField";

export const ProductForm = ({
	formik,
	handleSubmit,
	disabledFields,
	children,
}: ProductFormProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	const handleBackOnClick = () => {
		navigate(-1);
	};
	return (
		<form onSubmit={handleSubmit} className="p-fluid">
			<div className="flex flex-column">
				<div className="flex flex-row justify-content-between mb-3">
					<Button
						type={ButtonType.Button}
						onClick={handleBackOnClick}
						label={t("actions.back")}
					/>
					<Button
						disabled={!formik.isValid}
						type={ButtonType.Submit}
						icon={EpicIcons.SAVE}
						label={t("actions.save")}
					/>
				</div>
				<ValidatedField<ProductFormState, string>
					name={"title"}
					label={t("product.nameLabel")}
					required={true}
					disabled={disabledFields?.includes("title")}
					component={DefaultTextFieldComponent}
					formikConfig={formik}
				/>
				<ValidatedField<ProductFormState, boolean>
					name={"isHidden"}
					label={t("product.hidden")}
					required={true}
					component={DefaultSwitchComponent}
					disabled={disabledFields?.includes("isHidden")}
					formikConfig={formik}
				/>
				<ValidatedField<ProductFormState, number>
					name={"netPrice"}
					label={t("product.netPrice")}
					disabled={disabledFields?.includes("netPrice")}
					component={DefaultPriceFieldComponent}
					formikConfig={formik}
				/>
				<ValidatedField<ProductFormState, boolean>
					name={"isTaxFree"}
					label={t("product.taxFree")}
					required={true}
					component={DefaultSwitchComponent}
					disabled={disabledFields?.includes("isHidden")}
					formikConfig={formik}
				/>
				{children}
			</div>
		</form>
	);
};
